import { type ReactNode, createContext, useContext, useState } from "react";
import { AppLayout } from "./AppLayout";

export interface ILayoutContext {
  paddingBottom: number;
  setPaddingBottom: (padding: number) => void;
}

const LayoutContext = createContext<ILayoutContext | null>(null);

export function useLayoutContext() {
  const layoutContext = useContext(LayoutContext);
  if (!layoutContext) throw new Error("No LayoutContext found!");

  return layoutContext;
}

export function LayoutContextProvider({ children }: { children: ReactNode }) {
  const [paddingBottom, setPaddingBottom] = useState(0);
  return (
    <LayoutContext.Provider
      value={{
        setPaddingBottom,
        paddingBottom,
      }}
    >
      <AppLayout style={{ paddingBottom: `${paddingBottom}px` }}>
        {children}
      </AppLayout>
    </LayoutContext.Provider>
  );
}

export default LayoutContext;
